// src/pages/Auth.jsx
import AuthForm from "../auth/AuthForm";

export default function AuthPage() {
  return <AuthForm />;
}

